import classNames from "classnames";
import React from "react";

export const BoxContent = ({ children, className }) => {
  return (
    <div className={classNames("box__content", className)}>{children}</div>
  );
};
